class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    var getFilterRemoveData = $(
      "#FacetsWrapperDesktop > .active-facets-desktop"
    ).html();

    $("#filter-clone").html(getFilterRemoveData);

    var filterContainers = document.getElementsByClassName(
      "filter-container-js"
    );
    for (var container of filterContainers) {
      var sections = container.querySelectorAll(".default-filter-js");

      for (var section of sections) {
        var totalCount = section.querySelectorAll(
          ".filter-ul-js li.list-menu__item"
        ).length;
        var hiddenCount = section.querySelectorAll(
          ".filter-ul-js li.list-menu__item.facet-disable-checked"
        ).length;
        if (totalCount == hiddenCount) {
          section.classList.add("visually-hidden");
        } else {
          section.classList.remove("visually-hidden");
        }
      }
    }

    this.debouncedOnSubmit = debounce((event) => {
      console.log("FacetFiltersForm: debouncedOnSubmit called", event.target);
      const loadingElement = document.querySelector(".collection-loading");
      if (loadingElement) loadingElement.classList.add("has-active");
      this.onSubmitHandler(event);
    }, 300);

    const facetForm = this.querySelector("form");
    console.log("FacetFiltersForm: Form found", facetForm?.id, facetForm);

    if (!facetForm) {
      console.error("FacetFiltersForm: Form not found!");
      return;
    }

    facetForm.addEventListener("input", (event) => {
      console.log(
        "FacetFiltersForm: input event received on form",
        event.target,
        event.target.type
      );
      this.debouncedOnSubmit(event);
    });

    // Add change listener for checkboxes to ensure they trigger updates
    facetForm.addEventListener("change", (event) => {
      console.log(
        "FacetFiltersForm: change event received",
        event.target,
        event.target.type
      );
      if (event.target.type === "checkbox") {
        console.log(
          "FacetFiltersForm: checkbox change detected, triggering update"
        );
        this.debouncedOnSubmit(event);
      }
    });

    // Direct listener on checkboxes
    const checkboxes = facetForm.querySelectorAll('input[type="checkbox"]');
    console.log("FacetFiltersForm: Found checkboxes", checkboxes.length);

    // Check if checkboxes have names starting with filter
    checkboxes.forEach((checkbox, idx) => {
      console.log(`Checkbox ${idx}:`, {
        name: checkbox.name,
        value: checkbox.value,
        id: checkbox.id,
        checked: checkbox.checked,
      });

      checkbox.addEventListener("click", (event) => {
        console.log(
          "FacetFiltersForm: Direct click on checkbox",
          event.target.name,
          event.target.checked
        );
      });

      checkbox.addEventListener("change", (event) => {
        console.log(
          "FacetFiltersForm: Direct change on checkbox",
          event.target.name,
          event.target.checked
        );
      });
    });

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");

    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop"
    );
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner"
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove("hidden"));
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        const loadingElement = document.querySelector(".collection-loading");
        if (loadingElement) loadingElement.classList.remove("has-active");
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === "function")
          initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === "function")
      initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;

    document
      .getElementById("ProductGridContainer")
      .querySelectorAll(".scroll-trigger")
      .forEach((element) => {
        element.classList.add("scroll-trigger--cancel");
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");

    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner"
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add("hidden"));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (
        !Array.from(facetDetailsElementsFromFetch).some(
          ({ id }) => currentElement.id === id
        )
      ) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter(
      (element) => !matchesId(element)
    );
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(
      matchesId
    );

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML =
          elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } =
            facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document
            .querySelector(`#${elementToRender.parentElement.id} .js-filter`)
            .before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest(".js-filter").id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(
          countsToRender,
          event.target.closest(".js-filter")
        );
        FacetFiltersForm.renderMobileCounts(
          countsToRender,
          document.getElementById(closestJSFilterID)
        );

        const newFacetDetailsElement =
          document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains(
          "mobile-facets__details"
        )
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate =
          newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute("type") === "text";

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    document
      .getElementById("FacetFiltersFormMobile")
      .closest("menu-drawer")
      .bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector(".facets__summary");
    const sourceSummary = source.querySelector(".facets__summary");

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector(".facets__header");
    const sourceHeaderElement = source.querySelector(".facets__header");

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector(".facets-wrap");
    const sourceWrapElement = source.querySelector(".facets-wrap");

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(
        target.querySelector("show-more-button .label-show-more.hidden")
      );
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll(".facets__item.hidden")
          .forEach((hiddenItem) =>
            hiddenItem.classList.replace("hidden", "show-more-item")
          );
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector(".mobile-facets__list");
    const sourceFacetsList = source.querySelector(".mobile-facets__list");

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form"
    );
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form")
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile =
        event.target.closest("form").id === "FacetFiltersFormMobile";

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm"
          ) {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join("&"), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

// Global listener to ensure checkbox changes trigger form updates
document.addEventListener("change", (event) => {
  if (
    event.target.type === "checkbox" &&
    event.target.name?.startsWith("filter")
  ) {
    console.log("GLOBAL: Checkbox change detected", {
      name: event.target.name,
      value: event.target.value,
      checked: event.target.checked,
      form: event.target.closest("form")?.id,
    });

    // Find the form and then the parent facet-filters-form
    const form = event.target.closest("form");
    const facetFiltersForm = form?.parentElement;

    console.log("GLOBAL: Form element", form);
    console.log("GLOBAL: Parent element", facetFiltersForm);
    console.log("GLOBAL: Parent tagName", facetFiltersForm?.tagName);

    if (facetFiltersForm && facetFiltersForm.tagName === "FACET-FILTERS-FORM") {
      console.log(
        "GLOBAL: Found facet-filters-form, calling renderPage directly"
      );

      // Create FormData and call renderPage directly
      const formData = new FormData(form);
      const searchParams = new URLSearchParams(formData).toString();

      console.log("GLOBAL: searchParams", searchParams);

      const loadingElement = document.querySelector(".collection-loading");
      if (loadingElement) loadingElement.classList.add("has-active");

      FacetFiltersForm.renderPage(searchParams, event);
      console.log("GLOBAL: FacetFiltersForm.renderPage called");
    } else {
      console.error("GLOBAL: Could not find facet-filters-form parent");
    }
  }
});

class PriceRange extends HTMLElement {
  connectedCallback() {
    // Ensure initialization happens only once
    if (!this.initialized) {
      this.initialize();
      this.initialized = true;
    }
  }

  disconnectedCallback() {
    // Clean up event listeners when element is removed
    if (this.minInput) {
      this.minInput.removeEventListener("input", this.handleInput);
      this.minInput.removeEventListener("change", this.triggerFormUpdate);
    }
    if (this.maxInput) {
      this.maxInput.removeEventListener("input", this.handleInput);
      this.maxInput.removeEventListener("change", this.triggerFormUpdate);
    }
  }

  initialize() {
    // Wait a bit to ensure FacetFiltersForm is fully initialized
    setTimeout(() => {
      this.setupRangeSlider();
    }, 100);
  }

  setupRangeSlider() {
    const rangeInputs = this.querySelectorAll("input[type='range']");
    const minInput = rangeInputs[0];
    const maxInput = rangeInputs[1];
    const minValueDisplay = this.querySelector(".min-value-display");
    const maxValueDisplay = this.querySelector(".max-value-display");
    const progressBar = this.querySelector(".js-range-progress");
    const rangeMax = parseFloat(minInput?.getAttribute("max")) || 0;

    if (!minInput || !maxInput || !progressBar) {
      console.error("PriceRange: Missing required elements", {
        minInput: !!minInput,
        maxInput: !!maxInput,
        progressBar: !!progressBar,
        rangeInputs: rangeInputs.length,
      });
      return;
    }

    const updateProgress = () => {
      const minValue = parseFloat(minInput.value) || 0;
      const maxValue = parseFloat(maxInput.value) || rangeMax;

      // Ensure min doesn't exceed max and vice versa
      if (minValue > maxValue) {
        const temp = minInput.value;
        minInput.value = maxInput.value;
        maxInput.value = temp;
        return updateProgress();
      }

      const minPercent = rangeMax > 0 ? (minValue / rangeMax) * 100 : 0;
      const maxPercent = rangeMax > 0 ? (maxValue / rangeMax) * 100 : 100;

      if (progressBar) {
        progressBar.style.left = `${minPercent}%`;
        progressBar.style.right = `${100 - maxPercent}%`;
      }

      if (minValueDisplay) {
        minValueDisplay.textContent = Math.round(minValue);
      }
      if (maxValueDisplay) {
        maxValueDisplay.textContent = Math.round(maxValue);
      }
    };

    this.handleInput = (e) => {
      const currentValue = parseFloat(e.target.value);

      if (e.target === minInput) {
        const maxVal = parseFloat(maxInput.value);
        if (currentValue > maxVal) {
          minInput.value = maxVal;
          return updateProgress();
        }
      } else {
        const minVal = parseFloat(minInput.value);
        if (currentValue < minVal) {
          maxInput.value = minVal;
          return updateProgress();
        }
      }

      updateProgress();
    };

    // Add event listeners
    minInput.addEventListener("input", this.handleInput, false);
    maxInput.addEventListener("input", this.handleInput, false);

    // Trigger form input event to update products (same as other filters)
    const facetForm = this.closest("facet-filters-form");
    const form = facetForm?.querySelector("form");

    console.log("PriceRange: Setup", {
      facetForm: !!facetForm,
      form: !!form,
      formId: form?.id,
      minInputName: minInput.name,
      maxInputName: maxInput.name,
    });

    this.triggerFormUpdate = () => {
      console.log("PriceRange: triggerFormUpdate called");
      if (form && !this.isUpdating) {
        this.isUpdating = true;
        console.log(
          "PriceRange: Calling FacetFiltersForm.renderPage directly",
          {
            minValue: minInput.value,
            maxValue: maxInput.value,
          }
        );

        // Create search params from form data
        const formData = new FormData(form);
        const searchParams = new URLSearchParams(formData).toString();

        console.log("PriceRange: searchParams", searchParams);

        // Call FacetFiltersForm.renderPage directly
        if (window.FacetFiltersForm && FacetFiltersForm.renderPage) {
          const loadingElement = document.querySelector(".collection-loading");
          if (loadingElement) loadingElement.classList.add("has-active");
          FacetFiltersForm.renderPage(searchParams, null);
          console.log("PriceRange: FacetFiltersForm.renderPage called");
        } else {
          console.error(
            "PriceRange: FacetFiltersForm.renderPage not available"
          );
        }

        // Reset flag after a short delay to allow render to complete
        setTimeout(() => {
          this.isUpdating = false;
        }, 300);
      } else if (this.isUpdating) {
        console.log("PriceRange: Update already in progress, skipping");
      } else {
        console.error("PriceRange: Form not found");
      }
    };

    // Trigger form update on change (after user releases the slider)
    minInput.addEventListener("change", this.triggerFormUpdate, false);
    maxInput.addEventListener("change", this.triggerFormUpdate, false);

    // Initialize progress bar immediately
    updateProgress();

    // Store references for later use
    this.minInput = minInput;
    this.maxInput = maxInput;
    this.updateProgress = updateProgress;
  }

  onRangeChange(event) {
    if (event && event.target) {
      this.adjustToValidValues(event.target);
      this.setMinAndMaxValues();
    }
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern =
      /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input[type='range']");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (!minInput || !maxInput) return;

    const minVal = parseFloat(minInput.value) || 0;
    const maxVal =
      parseFloat(maxInput.value) ||
      parseFloat(maxInput.getAttribute("max")) ||
      0;
    const rangeMax = parseFloat(maxInput.getAttribute("max")) || 0;

    // Set data attributes for validation
    minInput.setAttribute("data-min", 0);
    minInput.setAttribute("data-max", maxVal);
    maxInput.setAttribute("data-min", minVal);
    maxInput.setAttribute("data-max", rangeMax);
  }

  adjustToValidValues(input) {
    if (!input) return;
    const value = Number(input.value);
    const min = Number(input.getAttribute("data-min")) || 0;
    const max =
      Number(input.getAttribute("data-max")) ||
      parseFloat(input.getAttribute("max")) ||
      0;

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);
